import React, { useState, useEffect, useRef } from "react";
import { withRouter, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import { Modal, ModalHeader, ModalBody, Alert, ModalFooter, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  clearGlobalzzId,
  setGlobalzzId,
} from "../../redux/actions/user";
import { GetTicket, GetRecentTickets } from "../../redux/actions/maintainance";
import {
  GetVehicles,
  GetSpots,
  ToggleArchiveParking,
} from "../../redux/actions/parking";
import {
  ViewPayment,
  clearPaymentDetails,
  GetRecentPayments,
} from "../../redux/actions/payments";
import Maintenance from "../maintenance";
import PaymentForm from "../payments/paymentForm.jsx";
import ECHCForm from "../payments/ECHCForm.jsx";
import ParkingForm from "../parking/parkingForm";
import WrapperComponent from "../wrapperComponent";
import SweetAlert from "react-bootstrap-sweetalert";
import moment from "moment";
import { Notify } from "../../helpers/notification";
import { useTranslation } from "react-i18next";

const Dashboard = React.memo(
  ({
    history,
    ViewPayment,
    clearPaymentDetails,
    metaData = {},
    user = {},
    paymentDetail,
    GetVehicles,
    GetSpots,
    ToggleArchiveParking,
    vehicles = [],
    globalZZID,
    clearGlobalzzId,
    setGlobalzzId,
    GetTicket,
    GetRecentTickets,
    Leases,
    appLoading,
    isMaintenanceBlocked,
    recentPayments = [],
    GetRecentPayments,
  }) => {
    // const _6MonthsMiliseconds = 15778800000;
    const [displayData, setDisplayData] = useState({});
    const [recentTickets, setRecentTickets] = useState([]);
    const [loadingTickets, setLoadingTickets] = useState(false);
    const [loadingVehicles, setLoadingVehicles] = useState(false);
    const [modalDialog, setModalDialog] = useState(false);
    const [headerTitle, setHeaderTitle] = useState("");
    const [edit, setEdit] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [modalBody, setModalBody] = useState("");
    const [openAlert, setOpenAlert] = useState(false);
    const [download, setDownload] = useState(false);
    const [selectedArchived, setSelectedArchived] = useState("");
    const [action, setAction] = useState("");
    const [, setIsCompleted] = useState(false);
    const [isFailed, setIsFailed] = useState(false);
    const [openPaymentAlert, setOpenPaymentAlert] = useState(false);
    const [transactionResponse, setTransactionResponse] = useState("");
    const [cross, setCross] = useState(true);
    const [showNotAassiged, setShowNotAssigned] = useState(false);
    const [resfreshData, setRefreshData] = useState(false);
    
    const [modalError, setModalError] = useState('');
    const [selectedDetailPayment, setSelectedDetailPayment] = useState(null);
    const [detailModalOpen, setDetailModalOpen] = useState(false);
    const [activeDetailTab, setActiveDetailTab] = useState("tenders");
    const myRef = useRef();
    let query = new URLSearchParams(useLocation().search);
    let zzid = query.get("id");
    let urlAction = query.get("action");

    const { t } = useTranslation();

    const openDetailModal = (item) => {
      setSelectedDetailPayment(item);
      setActiveDetailTab("tenders");
      setDetailModalOpen(true);
    };

    const closeDetailModal = () => {
      setDetailModalOpen(false);
      setSelectedDetailPayment(null);
    };

    useEffect(() => {
      if (Leases && Leases.length && !recentPayments.length) {
        GetRecentPayments(() => {});
      }
      if (Leases && Leases.length) {
        setLoadingTickets(true);
        GetRecentTickets(5)
          .then(({ items = [] } = {}) => {
            setRecentTickets(items);
          })
          .finally(() => setLoadingTickets(false));
        setLoadingVehicles(true);
        Promise.resolve(GetVehicles()).finally(() => setLoadingVehicles(false));
        GetSpots();
      }
      zzid && setGlobalzzId({ zzid });
      urlAction &&
        setAction(
          urlAction === "verify" ? "Verified by Tenant" : "Re-Opened by Tenant"
        );
      if (globalZZID.action) {
        setAction(
          globalZZID.action === "verify"
            ? "Verified by Tenant"
            : "Re-Opened by Tenant"
        );
      }
      // eslint-disable-next-line
    }, [resfreshData]);

    // function to sort metaData object
    const sorter = (metaData) => {
      let obj = {};
      let b = moment().format("MM/DD/YYYY");
      let data = { ...metaData };
      data["maintainence_tickets"] = data["maintainence_tickets"].filter(
        (item) => {
          let a = moment(item["Lease_MAIN::Date_Max"], "MM/DD/YYYY");
          return (
            Math.abs(a.diff(b, "days")) < 22 ||
            [
              "new",
              "verified",
              "closed",
              "scheduled",
              "scheduled - confirmed",
              "re-opened by tenant",
              "verified by tenant"
            ].includes(item["Lease_MAIN::Status"]?.toLowerCase())
          );
        }
      );
      console.log(data);
      const myFun = (item) => {
        obj[item] = data[item].slice(0, 5);
      };
      data = Object.keys(data).forEach(myFun);
      data = obj;
      setDisplayData(data);
    };

    useEffect(() => {
      sorter(metaData);
    }, [metaData]);
    console.log(action);
    /********
      function which will run only for
      maintenance id present in url
    ********/
    const openMaintenanceTicket = (data) => {
      if (data) {
        if (data.fieldData["isVerifiedByTenant"] && action) {
          Notify("danger", "This ticket was already verified");
          history.push("/dashboard");
          return;
        } else if (data.fieldData["isReOpenedByTenant"] && action) {
          Notify("danger", "This ticket has already been re-opened");
          history.push("/dashboard");
          return;
        } else if (!data.fieldData["isClosed"] && action) {
          Notify("danger", "This ticket is still in progress");
          history.push("/dashboard");
          return;
        }
        setHeaderTitle("Maintenance Ticket");
        setEdit(true);
        toggleModal("maintenance");
      }
    };

    useEffect(() => {
      if (
        metaData?.maintainence_tickets?.length &&
        globalZZID &&
        globalZZID.zzid
      ) {
        let ele = [...metaData.maintainence_tickets];
        let item = ele.filter((e) => e["Lease_MAIN::zzID"] === globalZZID.zzid);
        clearGlobalzzId();
        if (item.length) {
          let b = moment().format("MM/DD/YYYY");
          let a = moment(item[0]["Lease_MAIN::Date_Max"], "MM/DD/YYYY");
          if (
            Math.abs(a.diff(b, "days")) > 21 &&
            ![
              "new",
              "verified",
              "closed",
              "scheduled",
              "scheduled - confirmed",
              "re-opened by tenant",
            ].includes(item[0]["Lease_MAIN::Status"].toLowerCase())
          ) {
            Notify("danger", "This ticket is too old");
            history.push("/dashboard");
            return;
          }
          GetTicket(
            {
             ...(item[0]?.mongo_id && {_id: item[0]?.mongo_id }), 
             ...(item[0]['Lease_MAIN::zzID'] && {zzID: item[0]['Lease_MAIN::zzID']})
            }, openMaintenanceTicket);
          setSelectedItem(item[0]);
        } else {
          Notify("danger", "No record found with Id provided");
          history.push("/dashboard");
        }
      }
      // eslint-disable-next-line
    }, [displayData]);
    /************ END OF FUNCTION ****************/

    // function to toggle modal
    const toggleModal = (value) => {
      if (value) {
        setModalBody(value);
        if (value !== "maintenance") {
          setCross(true);
        }
      }
      setModalDialog(!modalDialog);
    };

    
    // function which runs on modal close
    const closeModal = (bool) => {
      // After successful payment, refresh recent payments
      if (bool && (modalBody === "payment" || modalBody === "echc_payment")) {
        GetRecentPayments(() => {});
      }
      setEdit(false);
      setModalDialog(false);
      setSelectedItem({});
      setHeaderTitle("");
      setCross(true);
      modalBody === "payment" && clearPaymentDetails();
      setModalBody("");
      if (zzid) {
        setAction("");
        history.push("/dashboard");
      }
    };

    const closeModalAdd = (bool) => {
      setEdit(false);
      setModalDialog(false);
      setSelectedItem({});
      setHeaderTitle("");
      setCross(true);
      modalBody === "payment" && clearPaymentDetails();
      setModalBody("");
      if (zzid) {
        setAction("");
        history.push("/dashboard");
      }
      setShowNotAssigned(true);
    };

    // function to toggle parking
    const handleToggleParking = () => {
      const item = vehicles[selectedArchived];
      if (item) {
        const isArchived = item.isArchived ? "" : "1";
        ToggleArchiveParking(item.zzID, { isArchived }, closeModal);
        setOpenAlert(false);
      }
    };

    // function gets run on parking alert
    const openParkingAlert = (e, index) => {
      e.stopPropagation();
      index && setSelectedArchived(index);
      setOpenAlert(true);
    };

    useEffect(() => {
      if (paymentDetail.pdfData && download) {
        myRef.current.click();
      }
      // eslint-disable-next-line
    }, [paymentDetail]);

    // function to download payment pdf file
    const handlePdfDownload = (id) => {
      clearPaymentDetails();
      ViewPayment(id, `email=${user.Email_01}`);
      setDownload(true);
    };

    // function to toggle payment alert closing
    const togglePaymentAlert = () => {
      setOpenPaymentAlert(false);
      if (modalBody === "echc_payment" || modalBody === "payment") {
        closeModal();
      }
    };

    const statusTranslation = (text) => {
      return text === "New"
        ? t("maintenance-status.new")
        : text === "Verified"
        ? t("maintenance-status.verified")
        : text === "Verified by Tenant"
        ? t("maintenance-status.verified-tenant")
        : text === "Closed"
        ? t("maintenance-status.closed")
        : text === "Scheduled"
        ? t("maintenance-status.scheduled")
        : text === "Re-Opened by Tenant"
        ? t("maintenance-status.re-opened")
        : text === "Scheduled - Confirmed"
        ? t("maintenance-status.scheduled-confirmed")
        : text === "Canceled"
        ? t("maintenance-status.canceled")
        : text;
    };

    const categoryTranslation = (text) => {
      return text === "Cleaning"
        ? t("maintenance-category.cleaning")
        : text === "Plumbing"
        ? t("maintenance-category.plumbing")
        : text === "Extermination"
        ? t("maintenance-category.extermination")
        : text === "Electricity"
        ? t("maintenance-category.electricity")
        : text === "Scheduled"
        ? t("maintenance-category.scheduled")
        : text === "Carpentry"
        ? t("maintenance-category.carpentry")
        : text === "Landscaping"
        ? t("maintenance-category.landscaping")
        : text;
    };

    // const shouldUpdateEmailOrPhone=()=>{
    //   if(!user?.web_verifiedEmailTs || !user?.web_verifiedPhoneTs){
    //     return true;
    //   }
    //   const emailTsDate = new Date(user?.web_verifiedEmailTs)?.getTime();
    //   const phoneTsDate = new Date(user?.web_verifiedPhoneTs)?.getTime();
    //   if(!emailTsDate || !phoneTsDate){
    //     return true;
    //   }
    //   const dateMiliseconds = new Date().getTime();
    //   if(Math.abs(dateMiliseconds-emailTsDate)>_6MonthsMiliseconds || Math.abs(dateMiliseconds-phoneTsDate)>_6MonthsMiliseconds){
    //    return true; 
    //   }
    //   return false
    // }


    const renderExterminationErrorModal = () => {
      return (
        <Modal size="md" centered isOpen={modalError} toggle={()=> setModalError('')}>
           <ModalBody>
              <p style={{fontSize: 16}}>{modalError}</p>
           </ModalBody>
           <ModalFooter>
            <button className="btn btn-primary" onClick={()=> setModalError('')}>Close</button>
           </ModalFooter>
        </Modal>
      )
    }
  

    return (
      <div>
        {renderExterminationErrorModal()}
        {openAlert && (
          <SweetAlert
            showCancel
            confirmBtnText={t("sweetalert.continue")}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="default"
            title={t("sweetalert.title1")}
            onConfirm={() => handleToggleParking()}
            onCancel={() => {
              setSelectedArchived("");
              setOpenAlert(false);
            }}
          />
        )}
        {showNotAassiged && (
          <SweetAlert
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="default"
            title={t("modal.parking.no-designated-spot")}
            onConfirm={() => setShowNotAssigned(false)}
            onCancel={() => setShowNotAssigned(false)}
          />
        )}
        
        {openPaymentAlert ? (
          isFailed ? (
            <SweetAlert
              error
              confirmBtnText={t("sweetalert.okay")}
              confirmBtnBsStyle="error"
              title={t("sweetalert.failed")}
              onConfirm={() => togglePaymentAlert()}
            >
              {typeof transactionResponse === 'string' ? transactionResponse : transactionResponse?.message }
            </SweetAlert>
          ) : (
            <SweetAlert
              success
              confirmBtnText={t("sweetalert.okay")}
              confirmBtnBsStyle="success"
              title={t("sweetalert.success")}
              onConfirm={() => togglePaymentAlert()}
            >
              {typeof transactionResponse === 'string' ? transactionResponse : transactionResponse?.message }
            </SweetAlert>
          )
        ) : (
          ""
        )}
        <div className="d-none">
          <a
            download={paymentDetail?.fileName || "PaymentDataReport.pdf"}
            href={"data:application/pdf;base64," + paymentDetail?.pdfData}
          >
            <i className="fa fa-download" ref={myRef} />
          </a>
        </div>

        <Modal isOpen={modalDialog} toggle={() => toggleModal()}>
          {modalBody !== "pdf" && (
            <ModalHeader
              toggle={() => closeModal()}
              close={
                <button
                  className={
                    (edit || modalBody !== "maintenance") && cross
                      ? "close"
                      : "close d-none"
                  }
                  onClick={(toggle) => closeModal()}
                >
                  x
                </button>
              }
            >
              {headerTitle || "Ania Management"}{" "}
              {(headerTitle === "Maintenance Ticket" &&
                selectedItem["Lease_MAIN::zzIDFriendly"]) ||
                ""}
            </ModalHeader>
          )}
          <ModalBody className={`${modalBody === "pdf" ? "p-0" : ""}`}>
            {modalBody === "maintenance" && (
              <Maintenance
                item={selectedItem}
                edit={edit}
                action={action}
                closeModal={closeModal}
                setHeaderTitle={setHeaderTitle}
                setCross={setCross}
                setRefreshData={setRefreshData}
                resfreshData={resfreshData}
                setModalError={setModalError}
              />
            )}
            {modalBody === "payment" && (
              <PaymentForm
                // item={selectedItem}
                // edit={edit}
                closeModal={closeModal}
                setIsCompleted={setIsCompleted}
                setIsFailed={setIsFailed}
                setOpenPaymentAlert={setOpenPaymentAlert}
                setTransactionResponse={setTransactionResponse}
                setRefreshData={setRefreshData}
                resfreshData={resfreshData}
              />
            )}
            {modalBody === "echc_payment" && (
              <ECHCForm
                closeModal={closeModal}
                setIsFailed={setIsFailed}
                setIsCompleted={setIsCompleted}
                setOpenPaymentAlert={setOpenPaymentAlert}
                setTransactionResponse={setTransactionResponse}
                setRefreshData={setRefreshData}
                resfreshData={resfreshData}
              />
            )}
            {modalBody === "parking" && (
              <ParkingForm
                item={selectedItem}
                edit={edit}
                openParkingAlert={openParkingAlert}
                closeModal={closeModal}
                closeModalAdd={closeModalAdd}
                setRefreshData={setRefreshData}
                resfreshData={resfreshData}
              />
            )}
          </ModalBody>
          
        </Modal>
        {user &&
        user.leaseDetails &&
        (!user.leaseDetails["Lease_PROP::Address_Address01_finalDisplay"] ||
          !user.leaseDetails["Lease_PROP::Address_City"] ||
          !user.leaseDetails["Lease_PROP::Address_State"] ||
          !user.leaseDetails["Lease_PROP::Address_PostalCode"]) ? (
          <div className="row mb-2">
            <div className="col-12">
              <Alert color="pink" className="m-b-10">
              {t("dashboard.property_info_alert")}
							</Alert>
            </div>
          </div>
        ) : null}

      {user &&
        user.leaseDetails && user?.leaseDetails?.EvictionStopBoolean ? (
          <div className="row mb-2">
            <div className="col-12">
              <Alert color="pink" className="m-b-10">
                  {t('dashboard.eviction_stop_alert')}
                 </Alert>
            </div>
          </div>
        ) : null}

        {user &&
        user.leaseDetails && user?.leaseDetails?.['Lease__LESE::zzGLOBAL37_YYYYMM'] && !user?.leaseDetails?.EvictionStopBoolean ? (
          <div className="row mb-2">
            <div className="col-12">
              {user.leaseDetails?.['Lease_LEDG_balanceThisMonthWeb::zs_amountTotal'] 
                 && user.leaseDetails?.['Lease_LEDG_balanceThisMonthWeb::zs_amountTotal']<0 
               ? <Alert color="pink" className="m-b-10">
                  {t("dashboard.balance_due_for")} {moment(user.leaseDetails?.['Lease__LESE::zzGLOBAL37_YYYYMM']).format("MMMM YYYY")} <strong style={{color:'red'}}>: -${parseFloat(''+Math.abs(user.leaseDetails?.['Lease_LEDG_balanceThisMonthWeb::zs_amountTotal'])).toFixed(2)}</strong>
                 </Alert>
                : null
               }
            </div>
          </div>
        ) : null}




        {/* {shouldUpdateEmailOrPhone() ? (
          <div className="row mb-2">
            <div className="col-12">
              <div class="alert alert-pink" role="alert">
                {t("dashboard.expired_email_phone_alert")}
              </div>
            </div>
          </div>
        ) : null} */}

        <div className="row">
          <div className="col-12">
            <Panel>
              <PanelHeader noButton={true}>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="stats-title text-uppercase text-white font-weight-bold">
                      {t("card-title.payments")}
                    </div>
                    <div className="stats-desc">
                      {t("card-subtitle.payments")}
                    </div>
                  </div>

                  {appLoading ? (
                    <i className="fas fa-spinner fa-pulse"></i>
                  ) : null}

                  {user &&
                    user.leaseDetails &&
                    user.leaseDetails[
                      "Lease_PROP::Address_Address01_finalDisplay"
                    ] &&
                    user.leaseDetails["Lease_PROP::Address_City"] &&
                    user.leaseDetails["Lease_PROP::Address_State"] &&
                    user.leaseDetails["Lease_PROP::Address_PostalCode"] &&
                    !user.leaseDetails.EvictionStopBoolean &&
                    Leases &&
                    Leases.length > 0 && (
                      <UncontrolledDropdown className="pull-right">
                        <DropdownToggle caret className="btn btn-warning">
                          {t("payment-card-button.make-payment")}
                        </DropdownToggle>
                        <DropdownMenu>
                          <>
                            <DropdownItem
                              onClick={() => {
                                toggleModal("payment");
                                setHeaderTitle(t("modal.payment.header"));
                                setEdit(false);
                                setSelectedItem({});
                              }}
                            >
                              {t("payment-card-button.credit-card")}
                            </DropdownItem>
                          </>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    )}
                </div>
              </PanelHeader>
              <PanelBody>
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th className="text-nowrap">{t("card-table.payment.date")}</th>
                        <th className="text-nowrap text-right">{t("card-table.payment.rent-amount")}</th>
                        <th className="text-nowrap">Notes</th>
                        <th className="text-nowrap">Status</th>
                        <th className="text-nowrap">{t("card-table.payment.receipt")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recentPayments?.map((item, i) => (
                        <tr
                          key={i}
                          className={`text-nowrap ${
                            !item.isApproved && "text-muted font-italic"
                          }`}
                          style={{ cursor: "pointer" }}
                          onClick={() => openDetailModal(item)}
                        >
                          <td>
                            {item.zzCreatedDate ? moment(item.zzCreatedDate).format("MM/DD/YYYY") : "-"}
                          </td>
                          <td className="text-right">
                            <strong>
                              ${item.TotalLEDG
                                ? parseFloat(item.TotalLEDG).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                : "-"}
                            </strong>
                          </td>
                          <td style={{ whiteSpace: "normal", maxWidth: "400px" }}>
                            {item.Note || "-"}
                          </td>
                          <td>
                            {item.isApproved ? "Approved" : "Pending"}
                          </td>
                          <td>
                            <button
                              className="btn btn-info btn-xs"
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePdfDownload(item.zzID);
                              }}
                            >
                              PDF
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Payment Detail Modal */}
                <Modal isOpen={detailModalOpen} toggle={closeDetailModal}>
                  <ModalHeader toggle={closeDetailModal}>
                    Payment details
                  </ModalHeader>
                  <ModalBody>
                    <Nav tabs>
                      <NavItem style={{ flex: 1, textAlign: "center" }}>
                        <NavLink
                          className={activeDetailTab === "tenders" ? "active" : ""}
                          onClick={() => setActiveDetailTab("tenders")}
                          style={{ cursor: "pointer" }}
                        >
                          Tenders
                        </NavLink>
                      </NavItem>
                      <NavItem style={{ flex: 1, textAlign: "center" }}>
                        <NavLink
                          className={activeDetailTab === "allocations" ? "active" : ""}
                          onClick={() => setActiveDetailTab("allocations")}
                          style={{ cursor: "pointer" }}
                        >
                          Allocations
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={activeDetailTab} className="pt-3">
                      <TabPane tabId="tenders">
                        {selectedDetailPayment && (
                          <div className="table-responsive">
                            <table className="table table-sm">
                              <thead>
                                <tr>
                                  <th className="text-uppercase text-muted" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Payment Method</th>
                                  <th className="text-uppercase text-muted" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Last Four</th>
                                  <th className="text-uppercase text-muted text-right" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Amount</th>
                                  <th className="text-uppercase text-muted text-right" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Fee</th>
                                  <th className="text-uppercase text-muted text-right" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Charged</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(selectedDetailPayment.tenders || []).map((tender, ti) => (
                                  <tr key={ti}>
                                    <td>{tender.paymentMethod}</td>
                                    <td>{tender.lastFour}</td>
                                    <td className="text-right">${tender.amount}</td>
                                    <td className="text-right">{parseFloat(tender.fee) > 0 ? `$${tender.fee}` : ""}</td>
                                    <td className="text-right">${tender.charged}</td>
                                  </tr>
                                ))}
                                <tr style={{ backgroundColor: "#eef5f9" }}>
                                  <td colSpan="4" className="text-right"><strong>Grand total:</strong></td>
                                  <td className="text-right">
                                    <strong>${selectedDetailPayment.totalChargedAmount
                                      ? parseFloat(selectedDetailPayment.totalChargedAmount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                      : "0.00"}</strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                      </TabPane>
                      <TabPane tabId="allocations">
                        {selectedDetailPayment && (
                          <div className="table-responsive">
                            <table className="table table-sm">
                              <thead>
                                <tr>
                                  <th className="text-uppercase text-muted" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Month</th>
                                  <th className="text-uppercase text-muted" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Sub Category</th>
                                  <th className="text-uppercase text-muted text-right" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(selectedDetailPayment.allocations || []).map((alloc, ai) => (
                                  <tr key={ai}>
                                    <td>{alloc.month || "-"}</td>
                                    <td>{alloc.subCategory || "-"}</td>
                                    <td className="text-right">${alloc.amount
                                      ? parseFloat(alloc.amount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                      : "0.00"}</td>
                                  </tr>
                                ))}
                                {!(selectedDetailPayment.allocations || []).length && (
                                  <tr>
                                    <td colSpan="3" className="text-center text-muted">No allocations available</td>
                                  </tr>
                                )}
                                {(selectedDetailPayment.allocations || []).length > 0 && (
                                  <tr style={{ backgroundColor: "#eef5f9" }}>
                                    <td></td>
                                    <td><strong>Grand total</strong></td>
                                    <td className="text-right">
                                      <strong>${(selectedDetailPayment.allocations || [])
                                        .reduce((sum, a) => sum + (parseFloat(a.amount) || 0), 0)
                                        .toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </TabPane>
                    </TabContent>
                  </ModalBody>
                </Modal>

                {recentPayments.length >= 5 && (
                  <div className="row">
                    <span className="col-md-12 d-flex justify-content-end hover-pointer">
                      <b
                        className="text-warning"
                        onClick={(e) => {
                          e.stopPropagation();
                          history.push("/payments");
                        }}
                      >
                        {t("card-viewmore")}
                      </b>
                    </span>
                  </div>
                )}
              </PanelBody>
            </Panel>
          </div>
                    
            {
              isMaintenanceBlocked !=="1" ?  <div className="col-xl-12 col-md-12 col-sm-12">
              <Panel>
                <PanelHeader noButton={true}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="stats-title text-uppercase text-white font-weight-bold">
                        {t("card-title.maintenance")}
                      </div>
                      <div className="stats-desc">
                        {t("card-subtitle.maintenance")}
                      </div>
                    </div>
                    {loadingTickets ? (
                      <i className="fas fa-spinner fa-pulse"></i>
                    ) : null}
                    {Leases && Leases.length > 0 && (
                      <button
                        className="btn btn-warning btn-icon"
                        onClick={() => {
                          toggleModal("maintenance");
                          setHeaderTitle(
                            t("modal.maintenance.header-add-maintenance")
                          );
                          setEdit(false);
                          setSelectedItem({});
                        }}
                      >
                        <i className="fa fa-plus" />
                      </button>
                    )}
                  </div>
                </PanelHeader>
                <PanelBody>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th className="text-nowrap">
                            {t("card-table.maintenance.ticketno")}
                          </th>
                          <th className="text-nowrap">
                            {t("card-table.maintenance.date")}
                          </th>
                          <th className="text-nowrap">
                            {t("card-table.maintenance.category")}
                          </th>
                          <th className="text-nowrap">
                            {t("card-table.maintenance.status")}
                          </th>
                          <th className="text-nowrap"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {recentTickets.map((item, i) => (
                          <tr
                            key={i}
                            className="hover-pointer"
                            onClick={(e) => {
                              setEdit(true);
                              setSelectedItem(item);
                              setHeaderTitle("Maintenance Ticket");
                              toggleModal("maintenance");
                            }}
                          >
                            <td className="text-capitalize">
                              {item.friendlyId || "-"}
                            </td>
                            <td>{item.createdAt ? moment(item.createdAt).format("MM/DD/YYYY hh:mm A") : "-"}</td>
                            <td className="text-capitalize">
                              {categoryTranslation(item.type) ||
                                "-"}
                            </td>
                            <td>
                              {statusTranslation(item.status) ||
                                "-"}
                            </td>
                            <td className="text-center">
                              <i className="fa fa-chevron-right" />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {recentTickets.length >= 5 && (
                    <div className="row">
                      <span className="col-md-12 d-flex justify-content-end hover-pointer">
                        <b
                          className="text-warning"
                          onClick={(e) => {
                            e.stopPropagation();
                            history.push("/maintenance");
                          }}
                        >
                          {t("card-viewmore")}
                        </b>
                      </span>
                    </div>
                  )}
                </PanelBody>
              </Panel>
            </div> : null
            }
         

          {/* parking hidden until post-7th deploy */}
          {false && <div className="col-xl-6 col-md-6 col-sm-12">
            <Panel>
              <PanelHeader noButton={true}>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="stats-title text-uppercase text-white font-weight-bold">
                      {t("card-title.parking")}
                    </div>
                    <div className="stats-desc">
                      {t("card-subtitle.parking")}
                    </div>
                  </div>
                  {loadingVehicles ? (
                    <i className="fas fa-spinner fa-pulse"></i>
                  ) : null}
                  {Leases && Leases.length > 0 && (
                    <button
                      className="btn btn-warning btn-icon"
                      onClick={() => {
                        toggleModal("parking");
                        setHeaderTitle(t("modal.parking.header-add-parking"));
                        setEdit(false);
                        setSelectedItem({});
                      }}
                    >
                      <i className="fa fa-plus" />
                    </button>
                  )}
                </div>
              </PanelHeader>
              <PanelBody>
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="text-nowrap">
                          {t("card-table.parking.year")}
                        </th>
                        <th className="text-nowrap">
                          {t("card-table.parking.make")}
                        </th>
                        <th className="text-nowrap">
                          {t("card-table.parking.model")}
                        </th>
                        <th className="text-nowrap">
                          {t("card-table.parking.spot")}
                        </th>
                        <th className="text-nowrap"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {vehicles?.map(
                        (item, i) =>
                          !item.isArchived && (
                            <tr
                              key={item.zzID || i}
                              className="text-nowrap hover-pointer"
                              onClick={() => {
                                setSelectedArchived(i);
                                setEdit(true);
                                setSelectedItem(item);
                                setHeaderTitle(
                                  t("modal.parking.header-edit-parking")
                                );
                                toggleModal("parking");
                              }}
                            >
                              <td>{item.Year || "-"}</td>
                              <td>{item.Make || "-"}</td>
                              <td>{item.Model || "-"}</td>
                              <td>{item.SpotNumber || "-"}</td>
                              <td className="text-center">
                                <i className="fa fa-chevron-right" />
                              </td>
                            </tr>
                          )
                      )}
                    </tbody>
                  </table>
                </div>
                {/* {!loading && metaData.parking.length > 5 && (
                  <div className="row">
                    <span className="col-md-12 d-flex justify-content-end hover-pointer">
                      <b
                        className="text-warning"
                        onClick={(e) => {
                          e.stopPropagation();
                          history.push("/parking");
                        }}
                      >
                        {t("card-viewmore")}
                      </b>
                    </span>
                  </div>
                )} */}
              </PanelBody>
            </Panel>
          </div>}
        </div>
      </div>
    );
  }
);

const mapStateToProps = ({
  METADATA_REDUCER,
  USER_REDUCER,
  PAYMENT_REDUCER,
  MAINTENANCE_REDUCER,
  LOADING_REDUCER,
  PARKING_REDUCER,
}) => {
  return {
    metaData: METADATA_REDUCER,
    user: USER_REDUCER.userData,
    paymentDetail: PAYMENT_REDUCER.paymentDetail,
    globalZZID: MAINTENANCE_REDUCER.globalZZID,
    Leases: USER_REDUCER.AllLeases,
    pendingPayments: PAYMENT_REDUCER.pendings_payments,
    appLoading: LOADING_REDUCER.appLoading,
    isMaintenanceBlocked: USER_REDUCER?.userData?.leaseDetails && USER_REDUCER.userData?.leaseDetails['Lease_PROP::isMaintenanceBlcked'],
    recentPayments: PAYMENT_REDUCER.recentPayments,
    vehicles: PARKING_REDUCER.vehicles,
  };
};

const DashboardWrapper = (props) => (
  <WrapperComponent>
    <Dashboard {...props} />
  </WrapperComponent>
);

export default connect(mapStateToProps, {
  ViewPayment,
  clearPaymentDetails,
  GetVehicles,
  GetSpots,
  ToggleArchiveParking,
  clearGlobalzzId,
  setGlobalzzId,
  GetTicket,
  GetRecentTickets,
  GetRecentPayments,
})(withRouter(DashboardWrapper));
